import API from './api';

export default {

    // for csv, currently not ready, need to update server
    getPastSessions: (organization_id) => API({
        url: `sessions?past=true&organization_id=${organization_id}`,
        method: 'GET'
    }),

    // for athlete history - now supports summary mode
    getAthleteSessions: (athlete_id, summary = true) => API({
        url: `v2/athletes/${athlete_id}/sessions${summary ? '?summary=true' : ''}`,
        method: 'GET'
    }),

    // for getting full session details when expanded
    getAthleteSessionDetails: (athlete_id, session_id) => API({
        url: `v2/athletes/${athlete_id}/sessions/${session_id}/details`,
        method: 'GET'
    }),

};
